import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Avatar,
  IconButton,
  CircularProgress,
} from "@mui/material";
import {
  CloudUpload as CloudUploadIcon,
  Edit as EditIcon,
} from "@mui/icons-material";

const IMAGE_SLOTS = [
  { key: "coverImage", label: "Cover Image", ratio: "56.25%" },
  { key: "groomImage", label: "Groom Photo", ratio: "100%" },
  { key: "brideImage", label: "Bride Photo", ratio: "100%" },
  { key: "thumbnail", label: "Thumbnail", ratio: "100%" },
];

const InvitationImageUpload = ({
  images = {},
  onUpload,
  loading,
  uploadingKey,
}) => {
  const fileInputRefs = useRef({});

  const handleFileChange = (key, e) => {
    const file = e.target.files[0];
    if (file) onUpload(key, file);
    e.target.value = "";
  };

  return (
    <Grid container spacing={2}>
      {IMAGE_SLOTS.map((slot) => (
        <Grid item xs={12} sm={6} key={slot.key}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              {slot.label}
            </Typography>
            <Box
              sx={{
                position: "relative",
                pt: slot.ratio,
                borderRadius: 1,
                bgcolor: "grey.100",
                overflow: "hidden",
                cursor: "pointer",
              }}
              onClick={() => fileInputRefs.current[slot.key]?.click()}
            >
              {images[slot.key] ? (
                <Box
                  component="img"
                  src={images[slot.key]}
                  alt={slot.label}
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CloudUploadIcon sx={{ color: "grey.400", fontSize: 32 }} />
                  <Typography variant="caption" color="text.secondary">
                    Click to upload
                  </Typography>
                </Box>
              )}

              {uploadingKey === slot.key && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(0,0,0,0.4)",
                  }}
                >
                  <CircularProgress size={28} sx={{ color: "white" }} />
                </Box>
              )}

              {images[slot.key] && uploadingKey !== slot.key && (
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    bottom: 8,
                    right: 8,
                    bgcolor: "white",
                    "&:hover": { bgcolor: "grey.100" },
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
            <input
              ref={(el) => (fileInputRefs.current[slot.key] = el)}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(slot.key, e)}
              disabled={loading}
            />
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default InvitationImageUpload;
